const authUserName = state => state.userStore.user ? state.userStore.user.user_name : '';
const lastTimeActive = state => state.userStore.lastTimeActive ? state.userStore.lastTimeActive : null;

export default {
  authUserName,
  lastTimeActive,
};
